import type * as Types from '../../../../../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAiReportFeedbackMutationVariables = Types.Exact<{
  data: Types.CreateAiReportFeedbackInput;
}>;


export type CreateAiReportFeedbackMutationPage = { readonly __typename?: 'RootMutationType', readonly createAiReportFeedback: boolean };


export const CreateAiReportFeedbackDocument = gql`
    mutation CreateAiReportFeedback($data: CreateAiReportFeedbackInput!) {
  createAiReportFeedback(feedback_input: $data)
}
    `;
export type CreateAiReportFeedbackMutationFn = Apollo.MutationFunction<CreateAiReportFeedbackMutationPage, CreateAiReportFeedbackMutationVariables>;

/**
 * __useCreateAiReportFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateAiReportFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiReportFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiReportFeedbackMutation, { data, loading, error }] = useCreateAiReportFeedbackMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAiReportFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiReportFeedbackMutationPage, CreateAiReportFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiReportFeedbackMutationPage, CreateAiReportFeedbackMutationVariables>(CreateAiReportFeedbackDocument, options);
      }
export type CreateAiReportFeedbackMutationHookResult = ReturnType<typeof useCreateAiReportFeedbackMutation>;
export type CreateAiReportFeedbackMutationResult = Apollo.MutationResult<CreateAiReportFeedbackMutationPage>;
export type CreateAiReportFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateAiReportFeedbackMutationPage, CreateAiReportFeedbackMutationVariables>;